/*--------------------------------------------------------------
# JS Dom Utils
--------------------------------------------------------------*/

export function preventDefaultLinks() {
    document.querySelectorAll('a[href="#"]').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
        });
    });
}

export function installCookieConsentControls(openConsent) {
    document.addEventListener('click', event => {
        const control = event.target?.closest?.('[data-cookie-consent-open], a[href="#gerer-mes-cookies"]');
        if (!control) return;
        event.preventDefault();
        openConsent();
    });
}
